const namespace = 'in-wallet';

export const localStorageKeys = {
  lang: `${namespace}-lang`,
  hasProfile: `${namespace}-hasProfile`,
  devToken: `${namespace}-devToken`,
  hash: `${namespace}-hash`,
  tokenExp: `${namespace}-tokenExp`,
};
